import { render, staticRenderFns } from "./CustomersEdit.vue?vue&type=template&id=0538cb19&lang=pug"
import script from "./CustomersEdit.vue?vue&type=script&lang=ts"
export * from "./CustomersEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports